import { createContext } from "react";

const UserParametersContext = createContext('userParameters')

export default UserParametersContext